import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import SpinPage from '../../components/common/SpinPage';

function AuthVerify() {
  const { isAuthenticated } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      const redirectTo = '/dashboard';
      navigate(redirectTo, { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return <SpinPage />;
}

export default AuthVerify;
